<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Void Cash/Bank Payment Form
                <div class="card-header-actions">
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-row>
            <b-col lg="8">
                <b-row>
                    <b-col lg="6">
                        <b-input-group >
                            <b-input-group-prepend><label>Void Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor" readonly></b-form-input>
                        </b-input-group>
                    </b-col>   
                    <b-col lg="5">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Void Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>                      
                <b-input-group >
                    <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                        <b-form-input  v-model="model.uraian" readonly></b-form-input>
                </b-input-group>
                <b-row>
                    <b-col lg="4">      
                        <b-input-group>
                            <b-input-group-prepend><label>Payment Method</label></b-input-group-prepend>
                            <b-form-select v-model="model.jenis" :plain="true" :options="jenisPaym" disabled></b-form-select>                              
                        </b-input-group>
                    </b-col>
                    <b-col lg="8">
                    <b-input-group>
                        <b-input-group-prepend class="d-md-inline d-lg-none"><label>Payment To</label></b-input-group-prepend>
                        <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Payment To</span></b-input-group-prepend>
                        <b-form-input  v-model="model.terimadari" readonly></b-form-input>
                    </b-input-group>
                    </b-col>
                </b-row>                      
                <b-row >
                    <b-col lg="7" v-if="((model.jenis==='Cheque') || (model.jenis==='Giro'))">
                        <b-input-group >
                            <b-input-group-prepend><label>Cheque/Giro No.</label></b-input-group-prepend>
                            <b-form-input v-model="model.nomor_cek" readonly></b-form-input>
                            <b-input-group-prepend><span class="ml-2 pt-2 mr-1">Cq/Giro Date</span></b-input-group-prepend>
                            <b-form-input v-model="model.tgl_giro" type="date" disabled></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                    <b-col lg="5">                            
                        <b-input-group >
                            <b-input-group-prepend><label>Due/Efective Date</label></b-input-group-prepend>
                            <b-form-input v-model="model.tgl_terima" type="date"  disabled></b-form-input>                                        
                        </b-input-group>
                    </b-col>
                </b-row>             
                <b-row>
                    <b-col lg="7">
                        <b-input-group >
                            <b-input-group-prepend><label>Cash/bank Account</label></b-input-group-prepend>
                            <b-form-input readonly v-model="model.namabank" ></b-form-input>
                            <b-input-group-append>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                            </b-input-group-append>
                        </b-input-group>

                    </b-col>   
                    <b-col lg="5" v-if="(bankOnly=='1')">                            
                            <b-input-group >
                                <b-input-group-prepend class="d-md-inline d-lg-none"><label>Bank Account No.</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-none d-lg-inline"><span class="input-group-text">Bank Account#</span></b-input-group-prepend>
                                <b-form-input disabled v-model="model.nomorrek"></b-form-input>
                            </b-input-group>
                    </b-col>
                </b-row>                      
                <b-row>
                    <b-col lg="5">
                        <b-input-group >
                            <b-input-group-prepend><label>Trx. Amount</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number :minus="true" class="form-control text-right" separator="," v-model="model.valas_out" :precision="2" readonly></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="3">
                        <b-input-group >
                            <b-input-group-prepend><label>Bank Charges</label></b-input-group-prepend>
                                <b-input-group-prepend class="d-md-inline d-lg-none"><span class="input-group-text" style="width:70px;">{{model.matauang}}</span></b-input-group-prepend>
                            <my-number :minus="true" class="form-control text-right" separator="," v-model="model.bcharge" :precision="2" readonly></my-number>
                        </b-input-group>
                    </b-col>
                    <b-col lg="4">
                        <b-input-group >
                            <b-input-group-prepend><label>Exch. Rate {{model.matauang || ''}}</label></b-input-group-prepend>
                            <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{uanguser}}</span></b-input-group-prepend>
                            <my-number :minus="true" class="form-control text-right" separator="," v-model="model.kurstrx" :precision="6" readonly></my-number>
                        </b-input-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col lg="4">
                <v-dim :model="model" :key="updateDimHdr"></v-dim>
            </b-col>
            </b-row>              

            <b-card no-body>
            <b-tabs card v-model="tabIndex">
                <b-tab title="AP Payment" active>
                <b-table
                    class="mb-0"
                    ref="tblApPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="apPayment.items"
                    :fields="apPayment.fields"
                    :current-page="apPayment.page"
                    :per-page="apPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaibayar)="data">
                        {{data.item.nilaibayar|numFormat}}
                        </template>
                        <template v-slot:cell(kurskeap)="data">
                        {{data.item.kurskeap|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editApPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2 mr-3">
                            <b-col class="pr-4" cols="6">
                                <b-form-group label-cols=3 label-for="apInvoice" label="AP Invoice">
                                    <b-input-group >
                                        <b-form-input readonly v-model="apPayment.obj.invoice" :state="!$v.apPayment.obj.apinvkey.$error"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group  label-cols=3  label="Supplier/Vendor" >
                                    <b-form-input v-model="apPayment.obj.vendorinfo"  readonly></b-form-input>
                                </b-form-group>
                                <b-form-group  label-cols=3  label="Description" >
                                    <b-form-input v-model="apPayment.obj.uraian" disabled></b-form-input>
                                </b-form-group>
                                <b-form-group label-cols=3  label="AP Outstanding" >
                                    <b-input-group >
                                        <b-input-group-prepend>
                                        <span class="input-group-text" style="width:70px;">{{apPayment.obj.matauang}}</span>
                                        </b-input-group-prepend>
                                        <my-number :minus="true" class="form-control text-right" separator="," v-model="apPayment.obj.outstand" :precision="2" disabled></my-number>
                                    </b-input-group>
                                </b-form-group>
                                <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                    <b-input-group >
                                        <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{apPayment.obj.matauang}}</span></b-input-group-prepend>
                                        <my-number :minus="true" class="form-control text-right" separator="," v-model="apPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                        <b-form-input v-model="apPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3  label="Payment in Original AP" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{apPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="apPayment.obj.nilaibayar" :precision="2" :state="!$v.apPayment.obj.nilaibayar.$error" ></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="apPayment.obj.nilaibank" :precision="2" :state="!$v.apPayment.obj.nilaibank.$error"></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Exchange Rate Cash/Bank to AP" >
                                    <b-input-group >
                                        <b-input-group-prepend>
                                        <span class="input-group-text pl-2 pr-2" >{{model.matauang}} to {{apPayment.obj.matauang}}</span>
                                        </b-input-group-prepend>
                                        <my-number :minus="true" class="form-control text-right" separator="," v-model="apPayment.obj.kurskeap" :precision="6" :state="!$v.apPayment.obj.nilaibank.$error"></my-number>
                                    </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3 label="Cash Flow">
                                <b-input-group >
                                    <b-form-input readonly v-model="apPayment.obj.cashflow" :state="!$v.apPayment.obj.kodecash.$error" @keyup.13.native="showLkuCashflow('apPayment')"></b-form-input>
                                </b-input-group>
                            </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <div class="ml-2">
                        Showing
                        {{(apPayment.page - 1) * apPayment.limit + 1}}
                        to
                        {{apPayment.page * apPayment.limit}}
                        of
                        {{apPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="apPayment.total"
                        :per-page="apPayment.limit"
                        v-model="apPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Cash Advance">
                <b-table
                    class="mb-0"
                    ref="tblAdvPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="advPayment.items"
                    :fields="advPayment.fields"
                    :current-page="advPayment.page"
                    :per-page="advPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaiByr)="data">
                        {{data.item.nilaiByr|numFormat}}
                        </template>
                        <template v-slot:cell(kursKeAdv)="data">
                        {{data.item.kursKeAdv|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaiBank)="data">
                        {{data.item.nilaiBank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihKurs)="data">
                        {{data.item.selisihKurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editAdvPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="caNumber" label="Cash Advance No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="advPayment.obj.nomor" :state="!$v.advPayment.obj.advanKey.$error"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Employee" >
                                <b-form-input v-model="advPayment.obj.crewinfo"  readonly></b-form-input>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="advPayment.obj.keterangan" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Outstanding Request Amount" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{advPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="advPayment.obj.outstand" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                <b-input-group >
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{advPayment.obj.matauang}}</span></b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="advPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                    <b-form-input v-model="advPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="pr-4" cols="6">
                        <b-form-group label-cols=3  label="Payment in Original Amount" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{advPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number v-model="advPayment.obj.nilaiByr"  :state="!$v.advPayment.obj.nilaiByr.$error"  :disabled="(advPayment.obj.nonPJ)" class="form-control text-right" separator="," :precision="2" ></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," v-model="advPayment.obj.nilaiBank" :precision="2" :state="!$v.advPayment.obj.nilaiBank.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Exchange Rate Bank to Orig.Amt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text pl-2 pr-2" >{{model.matauang}} to {{advPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," :precision="6" v-model="advPayment.obj.kursKeAdv" :state="!$v.advPayment.obj.kursKeAdv.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3 label-for="advPayKodecash" label="Cash Flow">
                            <b-input-group >
                                <b-form-input readonly v-model="advPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('advPayment')" :state="!$v.advPayment.obj.kodecash.$error"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                            </div>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <div class="ml-2">
                        Showing
                        {{(advPayment.page - 1) * advPayment.limit + 1}}
                        to
                        {{advPayment.page * advPayment.limit}}
                        of
                        {{advPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="advPayment.total"
                        :per-page="advPayment.limit"
                        v-model="advPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>

                </b-tab>
                <b-tab title="Adv.Settle (Excess Expenses)">
                <b-table
                    class="mb-0"
                    ref="tblAdvSetPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="advSetPayment.items"
                    :fields="advSetPayment.fields"
                    :current-page="advSetPayment.page"
                    :per-page="advSetPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaiByr)="data">
                        {{data.item.nilaiByr|numFormat}}
                        </template>
                        <template v-slot:cell(kursBankKeAdv)="data">
                        {{data.item.kursBankKeAdv|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaiBank)="data">
                        {{data.item.nilaiBank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihKurs)="data">
                        {{data.item.selisihKurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editAdvSetPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="advSetNumber" label="Advance Settlement No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="advSetPayment.obj.nomor" @keyup.13.native="lkuAdvSetShow=true" :state="!$v.advSetPayment.obj.advSttlKey.$error"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Employee" >
                                <b-form-input v-model="advSetPayment.obj.crewinfo"  readonly></b-form-input>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="advSetPayment.obj.keterangan" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Outstanding Exceeds Expense" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="advSetPayment.obj.outstand" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                <b-input-group >
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span></b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="advSetPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                    <b-form-input v-model="advSetPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="pr-4" cols="6">
                        <b-form-group label-cols=3  label="Payment in Original Amount" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{advSetPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," v-model="advSetPayment.obj.nilaiByr" :precision="2" :state="!$v.advSetPayment.obj.nilaiByr.$error" ></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," v-model="advSetPayment.obj.nilaiBank" :precision="2" :state="!$v.advSetPayment.obj.nilaiBank.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Exchange Rate Bank to Orig.Amt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text pl-2 pr-2">{{model.matauang}} to {{advSetPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," :precision="6" v-model="advSetPayment.obj.kursBankKeAdv" :state="!$v.advSetPayment.obj.kursBankKeAdv.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3 label-for="advSetKodecash" label="Cash Flow">
                            <b-input-group >
                                <b-form-input readonly v-model="advSetPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('advSetPayment')" :state="!$v.advSetPayment.obj.kodecash.$error"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                            </div>

                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <div class="ml-2">
                        Showing
                        {{(advSetPayment.page - 1) * advSetPayment.limit + 1}}
                        to
                        {{advSetPayment.page * advSetPayment.limit}}
                        of
                        {{advSetPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="advSetPayment.total"
                        :per-page="advSetPayment.limit"
                        v-model="advSetPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Expense Reimbursment">
                <b-table
                    class="mb-0"
                    ref="tblExpPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="expPayment.items"
                    :fields="expPayment.fields"
                    :current-page="expPayment.page"
                    :per-page="expPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(nilaiByr)="data">
                        {{data.item.nilaiByr|numFormat}}
                        </template>
                        <template v-slot:cell(kursKeExp)="data">
                        {{data.item.kursKeExp|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaiBank)="data">
                        {{data.item.nilaiBank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihKurs)="data">
                        {{data.item.selisihKurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editExpPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="expNumber" label="Expense Reimbursment No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="expPayment.obj.nomor" @keyup.13.native="lkuExpShow=true" :state="!$v.expPayment.obj.expenKey.$error"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Employee" >
                                <b-form-input v-model="expPayment.obj.crewinfo"  readonly></b-form-input>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="expPayment.obj.keterangan" disabled></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Outstanding Expense" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{expPayment.obj.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="expPayment.obj.outstand" :precision="2" disabled></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Not Posted Settlemnt" >
                                <b-input-group >
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{expPayment.obj.matauang}}</span></b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="expPayment.obj.byr_semu" :precision="2" disabled></my-number>
                                    <b-form-input v-model="expPayment.obj.byr_semu_doc" disabled class="ml-1"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                        </b-col>
                        <b-col class="pr-4" cols="6">
                        <b-form-group label-cols=3  label="Payment in Original Amount" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{expPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," v-model="expPayment.obj.nilaiByr" :precision="2" :state="!$v.expPayment.obj.nilaiByr.$error" ></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," v-model="expPayment.obj.nilaiBank" :precision="2" :state="!$v.expPayment.obj.nilaiBank.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3  label="Exchange Rate Bank to Orig.Amt" >
                            <b-input-group >
                                <b-input-group-prepend>
                                <span class="input-group-text pl-2 pr-2">{{model.matauang}} to {{expPayment.obj.matauang}}</span>
                                </b-input-group-prepend>
                                <my-number :minus="true" class="form-control text-right" separator="," :precision="6" v-model="expPayment.obj.kursKeExp" :state="!$v.expPayment.obj.kursKeExp.$error"></my-number>
                            </b-input-group>
                        </b-form-group>
                        <b-form-group label-cols=3 label-for="expKodecash" label="Cash Flow">
                            <b-input-group >
                                <b-form-input readonly v-model="expPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('expPayment')" :state="!$v.advSetPayment.obj.kodecash.$error"></b-form-input>
                            </b-input-group>
                        </b-form-group>

                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                            </div>

                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <div class="ml-2">
                        Showing
                        {{(expPayment.page - 1) * expPayment.limit + 1}}
                        to
                        {{expPayment.page * expPayment.limit}}
                        of
                        {{expPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="expPayment.total"
                        :per-page="expPayment.limit"
                        v-model="expPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Transfer Account">
                <b-table
                    class="mb-0"
                    ref="tblTranPayment"
                    outlined
                    striped hover small 
                    style="font-size:smaller;"
                    :items="tranPayment.items"
                    :fields="tranPayment.fields"
                    :current-page="tranPayment.page"
                    :per-page="tranPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(valas_in)="data">
                        {{data.item.valas_in|numFormat}}
                        </template>
                        <template v-slot:cell(kurskeap)="data">
                        {{data.item.kurskeap|numFormat('0.000')}}
                        </template>
                        <template v-slot:cell(nilaibank)="data">
                        {{data.item.nilaibank|numFormat}}
                        </template>
                        <template v-slot:cell(selisihkurs)="data">
                        {{data.item.selisihkurs|numFormat('0,0.00')}}
                        </template>

                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editTranPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                    </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2 mr-3">
                            <b-col class="pr-4" cols="6">
                                <b-input-group >
                                    <b-input-group-prepend><label>Transfer to Bank Acc.</label></b-input-group-prepend>
                                    <b-form-input readonly v-model="tranPayment.obj.namabank" @keyup.13.native="lkuBanktujuanShow=true" :state="!$v.tranPayment.obj.kodebank2.$error"></b-form-input>
                                </b-input-group>

                                <b-input-group >
                                    <b-input-group-prepend><label>Bank Account No.</label></b-input-group-prepend>
                                    <b-form-input disabled v-model="tranPayment.obj.nomorrek"></b-form-input>
                                    <b-input-group-append>
                                        <span class="input-group-text" style="width:70px;">{{tranPayment.obj.matauang2}}</span>
                                    </b-input-group-append>
                                </b-input-group>
                                <b-input-group >
                                    <b-input-group-prepend><label>Amount in Destination Acc.</label></b-input-group-prepend>
                                    <b-input-group-prepend><span class="input-group-text" style="width:70px;">{{tranPayment.obj.matauang2}}</span></b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="tranPayment.obj.valas_in" :precision="2" :state="!$v.tranPayment.obj.valas_in.$error" ></my-number>
                                </b-input-group>
                            </b-col>
                            <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="tranPayment.obj.nilaibank" :precision="2" :state="!$v.tranPayment.obj.nilaibank.$error"></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Exchange Rate to Destination" >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text pl-2 pr-2">{{model.matauang}} to {{tranPayment.obj.matauang2}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," :precision="6" v-model="tranPayment.obj.kurstrx" :state="!$v.tranPayment.obj.kurstrx.$error"></my-number>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3 label="Cash Flow">
                                <b-input-group >
                                    <b-form-input readonly v-model="tranPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('tranPayment')"></b-form-input>
                                </b-input-group>
                            </b-form-group>

                            </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                    <div class="ml-2">
                        Showing
                        {{(tranPayment.page - 1) * tranPayment.limit + 1}}
                        to
                        {{tranPayment.page * tranPayment.limit}}
                        of
                        {{tranPayment.total}}
                        entries
                    </div>    
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="tranPayment.total"
                        :per-page="tranPayment.limit"
                        v-model="tranPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
                <b-tab title="Other">
                <b-table
                    class="mb-0"
                    ref="tblOthPayment"
                    outlined
                    striped hover small
                    :items="othPayment.items"
                    :fields="othPayment.fields"
                    :current-page="othPayment.page"
                    :per-page="othPayment.limit"
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(umasuk)="data">
                        {{data.item.umasuk|numFormat}}
                        </template>
                        <template v-slot:cell(action)="data">
                        <div class="text-center">
                        <a href="javascript:void(0)" @click="editOthPayment(data.item,data.toggleDetails)">
                            <i class="fa fa-pencil"></i>
                        </a>
                        </div>
                        </template>
                    <template v-slot:row-details="row">
                    <b-card no-body class="row-details-form">
                        <b-row class="mt-2">
                        <b-col class="pr-4" cols="6">
                            <b-form-group label-cols=3 label-for="glAccount" label="GL Account No.">
                                <b-input-group >
                                    <b-form-input readonly v-model="othPayment.obj.glAccount" @keyup.13.native="lkuCoaShow=true" :state="!$v.othPayment.obj.kodeacc.$error"></b-form-input>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group  label-cols=3  label="Description" >
                                <b-form-input v-model="othPayment.obj.uraian" :state="!$v.othPayment.obj.uraian.$error"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols=3  label="Payment in Cash/Bank Amt." >
                                <b-input-group >
                                    <b-input-group-prepend>
                                    <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                                    </b-input-group-prepend>
                                    <my-number :minus="true" class="form-control text-right" separator="," v-model="othPayment.obj.umasuk" :precision="2" :state="!$v.othPayment.obj.umasuk.$error"></my-number>
                                    <b-input-group-append><span class="pt-2 ml-1" > DB &nbsp; ( <i class="fa fa-minus-square"></i> CR)</span></b-input-group-append>
                                </b-input-group>
                            </b-form-group>
                            <b-form-group label-cols=3 label-for="othPayKodecash" label="Cash Flow">
                                <b-input-group >
                                    <b-form-input readonly v-model="othPayment.obj.cashflow" @keyup.13.native="showLkuCashflow('othPayment')" :state="!$v.advSetPayment.obj.kodecash.$error"></b-form-input>
                                </b-input-group>
                            </b-form-group>

                        </b-col>
                        <b-col class="pr-4" cols="6">
                            <v-dim :model="othPayment.obj" :key="updateDimDtl"></v-dim>
                            
                        </b-col>
                        </b-row>
                        <b-row class="justify-content-center mb-2">
                            <div style="width:400px;">
                                <b-input-group >
                                    <b-input-group-append>
                                        <b-button class="btn btn-warning ml-1" @click="row.toggleDetails">Cancel</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                        </b-row>
                    </b-card>
                    </template>                        
                </b-table>
                <b-row>
                    <b-col cols="6">
                    <b-row>
                        <div class="ml-2 mt-1" >
                          Showing {{(othPayment.page - 1) * othPayment.limit + 1}}
                          to <span v-if="((othPayment.page * othPayment.limit)>othPayment.total)">{{othPayment.total}}</span> <span v-else>{{othPayment.page * othPayment.limit}}</span>
                          of {{othPayment.total}} entries,   <span class="mr-1">limit per page :</span> 
                          <select  v-model="othPayment.limit"  style="width:60px;">
                            <option>5</option>                            
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                            <option>40</option>                            
                            <option>50</option>                            
                          </select>
                        </div>
                    </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="othPayment.total"
                        :per-page="othPayment.limit"
                        v-model="othPayment.page"
                    ></b-pagination>
                    </b-col>
                </b-row>
                </b-tab>
            </b-tabs>
            </b-card>    
            <b-row>
                <b-col cols="4">
                    <b-form-group  label-cols=3  label="Total Detail Payment" >
                        <b-input-group >
                            <b-input-group-prepend>
                            <span class="input-group-text" style="width:70px;">{{model.matauang}}</span>
                            </b-input-group-prepend>
                            <my-number :minus="true" class="form-control text-right" separator="," v-model="totalDtlPaym" :precision="2" disabled></my-number>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="8">
                    <div class="text-right">
                        <button v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                        <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<style lang="scss">
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 150px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dimReadonly";
import tranbank from "../../apis/tranbank";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, minValue, maxLength, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim},
  mixins: [validationMixin],
  validations: {
        model: {
            trvoidkey: { required },
            isvoid: { required },
            tanggal: { required },
        },
    apPayment: {
        obj: {
            apinvkey: { required },
            kodecash: { required },
            nilaibayar: { required, minValue:minValue(0.01) },
            nilaibank: { required, minValue: minValue(0.01) },
            kurskeap: { required, minValue:minValue(0.001) }
        }
    },
    advPayment: {
        obj :{
            advanKey: { required },
            kodecash: { required },
            nilaiByr: { required, minValue:minValue(0.01) },
            nilaiBank: { required, minValue:minValue(0.01) },
            kursKeAdv: { required, minValue:minValue(0.0000001) }
        }
    },
    advSetPayment: {
        obj :{
            advSttlKey: { required },
            kodecash: { required },
            nilaiByr: { required, minValue:minValue(0.01) },
            nilaiBank: { required, minValue:minValue(0.01) },
            kursBankKeAdv: { required, minValue:minValue(0.0000001) }
        }
    },
    expPayment: {
        obj :{
            expenKey: { required },
            kodecash: { required },
            nilaiByr: { required, minValue:minValue(0.01) },
            nilaiBank: { required, minValue:minValue(0.01) },
            kursKeExp: { required, minValue:minValue(0.0000001) }
        }
    },
    tranPayment: {
        obj :{
            kodebank2: { required },
            matauang2: { required },
            // kodecash: { required },
            nilaibank: { required, minValue:minValue(0.01) },
            valas_in: { required, minValue:minValue(0.01) },
            kurstrx: { required, minValue:minValue(0.0000001) }
        }
    },
    othPayment: {
        obj :{
            kodeacc: { required },
            uraian: { required },
            kodecash: { required },
            umasuk: { required },
        }
    },

  }, 
  data() {
    return {
        currency:[{value:'IDR',text:'IDR'}],
        saveEnabled:true,
        inputBerlanjut: 0,
        inputLineBerlanjut: 0,
        jenisPaym : ['Cheque', 'Giro', 'Transfer', 'Debet R/K', 'Kredit R/K', 'Tunai'],
        model: {jenis:'Giro',kodecash:'-',
            kodebank: '',
            uraian: '',
            tanggal: '',
            jenis: 'Giro',
            matauang: this.$store.state.user.matauang,
            terimadari: '',
            valas_out: 0,
            kurstrx: 1
        },

        lblExchRate:"Exch. Rate to ",
        bankOnly:1,
        lkuBankaccountShow:false,
        lkuBanktujuanShow:false,
        lkuCashflowShow: false,
        lkuCashflowCaller:'apPayment',        
        tabIndex:0,
        tahun:new Date().getFullYear(),
        totalDtlPaym:0,
        updateDimHdr:false,
        updateDimDtl:true,
        apPayment: {
            items: [],
            selected:{},
            obj:{apinvkey:'', kodecash:'',vendor:'', vendorinfo:'',nilaibayar: 0, nilaibank: 0, kurskeap: 1, byr_semu:0},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "AP Number"
                },
                {
                    key: "invoice",
                    label: "Invoice Number",
                    thStyle: "width:150px",
                    sortable: true
                },
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaibayar",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurskeap",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuApShow: false,
        lkuApData:{},
        advPayment: {
            items: [],
            selected:{},
            obj :{
                advanKey: '',
                kodecash: '',
                nilaiByr: 0,
                nilaiBank: 0,
                kursKeAdv: 1, byr_semu:0
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "Request Number"
                },
                {
                    key: "keterangan",
                    label: "Cash Advance Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaiByr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kursKeAdv",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaiBank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihKurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuAdvShow: false,
        expPayment: {
            items: [],
            selected:{},
            obj :{
                expenKey: '',
                kodecash: '',
                nilaiByr: 0,
                nilaiBank: 0,
                kursKeExp: 1, byr_semu:0
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "Reimbursment Number"
                },
                {
                    key: "keterangan",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaiByr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kursKeExp",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaiBank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihKurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuExpShow: false,
        advSetPayment: {
            items: [],
            selected:{},
            obj :{
                advSttlKey: '',
                kodecash: '',
                nilaiByr: 0,
                nilaiBank: 0,
                kursBankKeAdv: 1, byr_semu:0
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "nomor",
                    thStyle: "width:150px",
                    label: "AP Number"
                },
                {
                    key: "keterangan",
                    label: "Description",
                },
                {
                    key: "matauang",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "nilaiByr",
                    label: "Settlement Original Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kursBankKeAdv",
                    label: "Exch.Rate to Original",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaiBank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihKurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuAdvSetShow: false,
        othPayment: {
            items: [],
            selected:{},
            obj :{
                kodeacc: '',
                uraian: '',
                kodecash: '',
                umasuk: 0,  DimDtl:{}
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "uraian",
                    label: "Description",
                },
                {
                    key: "glAccount",
                    label: "GL Account"
                },
                {
                    key: "umasuk",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        lkuCoaShow:false,
        tranPayment: {
            items: [],
            selected:{},
            obj :{
                kodebank2: '',
                matauang2: '',
                kodecash: '',
                nilaibank: 0,
                valas_in: 0,
                kurstrx: 1
            },
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "namabank",
                    thStyle: "width:150px",
                    label: "Trasfer To Bank/Cash"
                },
                {
                    key: "nomorrek",
                    label: "Account Number",
                    thStyle: "width:150px",
                    sortable: true
                },
                {
                    key: "matauang2",
                    thStyle: "width:40px",
                    label: "$,¥"
                },
                {
                    key: "valas_in",
                    label: "Amount in Destination Acc.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "kurstrx",
                    label: "Exch.Rate to Destination",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "nilaibank",
                    label: "Settlement in Bank/Cash Amt.",
                    thStyle: "width:140px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "selisihkurs",
                    label: "Gain/(Loss) Exch.Rate",
                    thStyle: "width:100px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
                {
                    key: "cashflow",
                    label: "Cashflow Acc.",
                    thStyle: "width:200px",
                    sortable: true
                },
                {
                    key: "action",
                    label: "Action",
                    thStyle: "width:60px",
                    thClass: "text-center",
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
    };
},
  computed: {
    uanguser(){
      return this.$store.state.user.matauang;
    },
    dimension(){
      return this.$store.state.dimension;
    },
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidApPayment() {
      this.$v.apPayment.obj.$touch();
      return this.$v.apPayment.obj.$invalid;
    },
    invalidAdvPayment() {
      this.$v.advPayment.obj.$touch();
      return this.$v.advPayment.obj.$invalid;
    },
    invalidExpPayment() {
      this.$v.expPayment.obj.$touch();
      return this.$v.expPayment.obj.$invalid;
    },
    invalidAdvSetPayment() {
      this.$v.advSetPayment.obj.$touch();
      return this.$v.advSetPayment.obj.$invalid;
    },
    invalidTranPayment() {
      this.$v.tranPayment.obj.$touch();
      return this.$v.tranPayment.obj.$invalid;
    },
    invalidOthPayment() {
      this.$v.othPayment.obj.$touch();
      return this.$v.othPayment.obj.$invalid;
    },
    caraBayar(){
        return this.model.jenis;
    },
    bankkas(){
        return this.model.kodebank;
    },
    bankkas2(){
        return this.tranPayment.obj.kodebank2;
    },
  },
  watch: {
      
    caraBayar: function(jenis) {
        if (jenis==='Tunai') {
            this.bankOnly='0';
        } else {
            this.bankOnly='1';
        }
        if (this.model.isbank!=this.bankOnly) {
            this.model.kodebank='';
            this.model.namabank='';
        }
    },    
    bankkas: function(kode) {
            if (this.uanguser.trim() == this.model.matauang.trim()) {
                this.model.kurstrx = 1;
            }
    },    
    bankkas2: function(kode) {
        // let acc = this.bankCashAcc.find(r => r.kode===kode);
        // if (acc){
        //     this.tranPayment.obj.namabank=acc.namabank || acc.namabank2;
        //     this.tranPayment.obj.nomorrek=acc.nomorrek;
        //     this.tranPayment.obj.matauang2=acc.matauang;
            if (this.tranPayment.obj.matauang2.trim() == this.model.matauang.trim()) {
                this.tranPayment.obj.kurstrx = 1;
                let sisa=(this.model.valas_out || 0) - this.totalDtlPaym - (this.model.bcharge||0);
                this.tranPayment.obj.valas_in = sisa;
                this.tranPayment.obj.nilaibank= sisa;
            }
        // }
    }, 
  },
  created: async function(){
      this.lblExchRate=`Exch. Rate to ${this.uanguser}`;

      if (this.$route.params.id) {
          toastr.info('Loading Payment Detail, please wait')
          try {
            const [a,data] = await Promise.all([tranbank.currency(),await tranbank.paymentdetail(this.$route.params)]) ;
            this.currency = a;

            // const data = await tranbank.paymentdetail(this.$route.params);  
            const row = data[0][0];
            if (row.trvoidkey) {
                this.saveEnabled=(row.poststatus === 0);
                row.tanggal = row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
                row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
                row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : '';
            } else {
                this.saveEnabled=true;
                row.nomor=`${row.nomor}/VOID`;           
                row.isvoid=1; 
                row.poststatus=0;
                row.valas_in = -1*row.valas_in;
                row.valas_out = -1*row.valas_out;
                row.bank_in = -1*row.bank_in;
                row.bank_out = -1*row.bank_out;
                row.bcharge = -1*row.bcharge;

                row.tanggal = row.tanggal ? moment().format('YYYY-MM-DD') : '';
                row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : '';
            }
            for (var key in row) {
                this.model[key] = row[key];
            }
            this.model.trvoidkey=row.trbankkey;
            this.model.trbankkey='';           
            this.apPayment.items = data[1];
            this.apPayment.total=this.apPayment.items.length;
            this.advPayment.items = data[2];
            this.advPayment.total=this.advPayment.items.length;
            this.advSetPayment.items = data[3];
            this.advSetPayment.total=this.advSetPayment.items.length;
            this.expPayment.items = data[4];
            this.expPayment.total=this.expPayment.items.length;
            this.othPayment.items = data[5];
            this.othPayment.total=this.othPayment.items.length;
            this.tranPayment.items = data[6];
            this.tranPayment.total=this.tranPayment.items.length;
            if (this.apPayment.items.length>0) {this.tabIndex=0;
            } else if (this.advPayment.items.length>0) {this.tabIndex=1;
            } else if (this.advSetPayment.items.length>0) {this.tabIndex=2;
            } else if (this.expPayment.items.length>0) {this.tabIndex=3;
            } else if (this.tranPayment.items.length>0) {this.tabIndex=4;
            } else if (this.othPayment.items.length>0) {this.tabIndex=5;}
            if (!(row.trvoidkey)) {
                this.apPayment.items.forEach((trx)=> {
                    trx.appaymkey = '';
                    trx.nilaibank = -1*trx.nilaibank;
                    trx.nilaibayar =  -1*trx.nilaibayar ;
                });
                this.advPayment.items.forEach((trx)=> {
                    trx.advPayKey='';
                    trx.nilaiByr=-1*trx.nilaiByr;
                    trx.nilaiBank=-1*nilaiByr;
                    trx.nomorSttl=''
                    trx.nilaiAdj=-1*trx.nilaiAdj
                    trx.nonPJ=-1*trx.nonPJ
                });
                this.expPayment.items.forEach((trx)=> {
                    trx.expPayKey='';
                    trx.nilaiByr=-1*trx.nilaiByr;
                    trx.nilaiBank=-1*nilaiByr;
                });
                this.advSetPayment.items.forEach((trx)=> {
                    trx.advStlDtlKey='';
                    trx.nilaiByr=-1*trx.nilaiByr;
                    trx.nilaiBank=-1*nilaiByr;
                });
                this.othPayment.items.forEach((trx)=> {
                    trx.tablekey=''
                    trx.umasuk=-1*trx.umasuk;
                    trx.ukeluar=-1*trx.ukeluar;
                });
                this.tranPayment.items.forEach((trx)=> {
                    trx.trbankkey2='';           
                    trx.valas_in = -1*trx.valas_in;
                    trx.bank_in = -1*trx.bank_in;
                });
            }
            this.calcTotalDtlPaym();
            this.tanggalBerubah();
            this.updateDimHdr = !this.updateDimHdr;
            // if (this.model.jenis==='Tunai'){
            //     this.bankAccount = this.bankCashAcc.filter(r => r.isbank==0);
            // } 
            // this.$forceUpdate();
            toastr.clear;
          } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
          }
      } 
  },
  methods: {
    save: async function () {
        console.log('Save Clicked');
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        this.saveEnabled=false;
        if (this.invalidModel) {
            console.log('validation model : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else if (Math.abs(this.totalDtlPaym - parseFloat(this.model.valas_out))>0.01) {
            toastr.error('[Transaction Amount] not Balance with [Total Detail Payment]', "ERROR MESSAGE");
            this.saveEnabled=true;            
        } else {
            this.model.TableName = 'tranbank';
            try {
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    this.model.nomor = this.model.nomor || '';
                    this.model.isvoid = this.model.isvoid || 0;
                    this.model.poststatus = this.model.poststatus || 0;
                    this.model.valas_in = this.model.valas_in || 0;
                    this.model.valas_out = this.model.valas_out || 0;
                    this.model.bcharge = this.model.bcharge || 0;

                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.mode='payment';
                    row.tanggal = moment(row.tanggal).format('YYYY-MM-DD');
                    row.tgl_giro = row.tgl_giro ? moment(row.tgl_giro).format('YYYY-MM-DD') : undefined;
                    row.tgl_terima = row.tgl_terima ? moment(row.tgl_terima).format('YYYY-MM-DD') : moment(row.tanggal).format('YYYY-MM-DD');

                    const kurspost=this.model.kurstrx;

                    let newApPayments = this.apPayment.items.reduce((newArr, item) => {
                        if ((item.apinvkey || '') != '') {
                            item.kurspost = kurspost;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    let newAdvPayments = this.advPayment.items.reduce((newArr, item) => {
                        if ((item.advanKey || '') != '') {
                            // item.kurspost = kurspost;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    let newAdvSetPayments = this.advSetPayment.items.reduce((newArr, item) => {
                        if ((item.advSttlKey || '') != '') {
                            item.kursBank = kurspost;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    let newExpPayments = this.expPayment.items.reduce((newArr, item) => {
                        if ((item.expenKey || '') != '') {
                            // item.kurspost = kurspost;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    let newOthPayments = this.othPayment.items.reduce((newArr, item) => {
                        if ((item.kodeacc || '') != '') {
                            // item.kurspost = kurspost;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);
                    let newTranPayments = this.tranPayment.items.reduce((newArr, item) => {
                        if ((item.kodebank2 || '') != '') {
                            // item.kurspost = kurspost;
                            item.kurspost = item.bank_in/item.valas_in;
                            newArr.push(item);
                        }
                        return newArr;
                    }, []);

                    row.apPayment=newApPayments;
                    row.advPayment = newAdvPayments;
                    row.advSetPayment = newAdvSetPayments;
                    row.expPayment = newExpPayments;
                    row.othPayment = newOthPayments;
                    row.tranPayment = newTranPayments;
                    // await tranbank.insert(row);
                    // toastr.success("Complete successfully", "Save Payment");
                    const hasil= await tranbank.insert(row);
                    toastr.success(`Success, Trx.Number ${hasil.nomor}`, "Save Payment",10000);
                    // this.close();
                    if (this.inputBerlanjut==0){
                        this.close();
                    } else {
                        this.saveEnabled=true;            
                        const _selected= {
                            kode: this.model.kodebank,
                            matauang: this.model.matauang,
                            namabank: this.model.namabank,
                            nomorrek: this.model.nomorrek,
                            isbank:this.model.isbank,
                            jenis: this.model.jenis
                        }
                        for (var key in this.model) {
                            this.model[key] = '';
                        }
                        this.model.kurstrx=1;
                        this.model.valas_out= 0;
                        this.model.tanggal = moment().format('YYYY-MM-DD');
                        this.model.tgl_terima = moment().format('YYYY-MM-DD');
                        this.model.kodebank=_selected.kode;
                        this.model.matauang=_selected.matauang;
                        this.model.namabank=_selected.namabank;
                        this.model.nomorrek=_selected.nomorrek;
                        this.model.isbank=_selected.isbank;
                        this.model.jenis=_selected.jenis;
                        
                        this.bankOnly=1;
                        this.tabIndex=0;
                        this.tahun=new Date().getFullYear();
                        this.totalDtlPaym=0;

                        this.apPayment.items=[];
                        this.advPayment.items=[];
                        this.expPayment.items=[];
                        this.tranPayment.items=[];

                        this.advSetPayment.items= [];
                        this.advSetPayment.selected= {};
            
                        this.othPayment.items= [];
                        this.othPayment.selected= {};
                        this.$v.model.$reset();                        
                    }

                } else {
                    console.log('dimValResult : ', dimValResult);
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                    this.saveEnabled=true;            
                }

            } catch (error) {
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
                this.saveEnabled=true;            
            }

        }
    },
    closeApPayment: function(){
        const opened= this.apPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editApPayment : function (obj,callback) {
        this.closeApPayment();
        this.apPayment.selected = obj;
        for (var key in this.apPayment.obj) {
            this.apPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.apPayment.obj[key] = obj[key];
        }
        callback();
    },
    closeAdvPayment: function(){
        const opened= this.advPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editAdvPayment : function (obj,callback) {
        this.closeAdvPayment();
        this.advPayment.selected = obj;
        for (var key in this.advPayment.obj) {
            this.advPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.advPayment.obj[key] = obj[key];
        }
        callback();
    },
    closeAdvSetPayment: function(){
        const opened= this.advSetPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editAdvSetPayment : function (obj,callback) {
        this.closeAdvSetPayment();
        this.advSetPayment.selected = obj;
        for (var key in this.advSetPayment.obj) {
            this.advSetPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.advSetPayment.obj[key] = obj[key];
        }
        callback();
    },
    closeExpPayment: function(){
        const opened= this.expPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editExpPayment : function (obj,callback) {
        this.closeExpPayment();
        this.expPayment.selected = obj;
        for (var key in this.expPayment.obj) {
            this.expPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.expPayment.obj[key] = obj[key];
        }
        callback();
    },
    closeOthPayment: function(){
        const opened= this.othPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editOthPayment : function (obj,callback) {
        this.closeOthPayment();
        this.othPayment.selected = obj;
        for (var key in this.othPayment.obj) {
            this.othPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.othPayment.obj[key] = obj[key];
        }
        this.dimension.forEach((dim) => {
            if (obj[dim.value]) {
                this.othPayment.obj[dim.value] = obj[dim.value];
                this.othPayment.obj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
                this.othPayment.obj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
            }
        });
        callback();
    },

    closeTranPayment: function(){
        const opened= this.tranPayment.items.find( r=> r._showDetails==true);
        if (opened) opened._showDetails=false;
    },
    editTranPayment : function (obj,callback) {
        this.closeTranPayment();
        this.tranPayment.selected = obj;
        for (var key in this.tranPayment.obj) {
            this.tranPayment.obj[key] = '';
        }
        for (var key in obj) {
            this.tranPayment.obj[key] = obj[key];
        }
        callback();
    },
    updateDimDtl2Hdr: function (dimDtl) {
        var dimHdr = this.model;
        this.dimension.forEach((dim) => {
            if ((dimDtl[dim.value]) && !(dimHdr[dim.value])) {
                dimHdr[dim.value] = dimDtl[dim.value];
                dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
                dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`] ;
            }
        });
        this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
        var dimHdr = this.model;
        dimDtl = dimDtl || this.othPayment.obj;
        this.dimension.forEach((dim) => {
            if ((dimHdr[dim.value]) && !(dimDtl[dim.value])) {
                dimDtl[dim.value] = dimHdr[dim.value];
                dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
                dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`] ;
            }
        });
        this.updateDimDtl = !this.updateDimDtl;
    },
    calcTotalDtlPaym: function () {
        let totalDtlPaym = this.model.bcharge || 0;
        this.apPayment.items.forEach((trx)=> {
            if (trx.apinvkey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.advPayment.items.forEach((trx)=> {
            if (trx.advanKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
        });
        this.expPayment.items.forEach((trx)=> {
            if (trx.expenKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
        });
        this.advSetPayment.items.forEach((trx)=> {
            if (trx.advSttlKey) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaiBank);
        });
        this.othPayment.items.forEach((trx)=> {
            if (trx.kodeacc) totalDtlPaym = totalDtlPaym + parseFloat(trx.umasuk);
        });
        this.tranPayment.items.forEach((trx)=> {
            if (trx.kodebank2) totalDtlPaym = totalDtlPaym + parseFloat(trx.nilaibank);
        });
        this.totalDtlPaym = totalDtlPaym;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    close(){
    //   router.push({name:'treasury.trxlist'});
      if (this.$store.state.prevRoute.name) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        router.push({name:'treasury.trxlist'});
      }
    }
  }
};
</script>
